import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { HeadToHeadResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Head-to-head record between two players (GET /ranking/stats/head-to-head).
 * Disabled until BOTH ids are present — a one-sided "me vs ?" is never fetched,
 * and a "me vs me" self-match is meaningless (the standing page suppresses it by
 * passing `undefined` for the second player). Counts render verbatim.
 */
export function useHeadToHead(
  playerA: string | undefined,
  playerB: string | undefined,
) {
  return useQuery<HeadToHeadResponse>({
    queryKey: queryKeys.compete.headToHead(playerA ?? "", playerB ?? ""),
    queryFn: () =>
      rankingApi.getHeadToHead(playerA as string, playerB as string),
    enabled: Boolean(playerA) && Boolean(playerB),
  });
}
